import React, {useState} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import Entypo from 'react-native-vector-icons/Entypo';
import {Colors} from '../../../../constants/Colors';

interface IDropDownFilter {
  title: string;
  onPress: () => void;
  image?: JSX.Element;
  color?: string;
  fontSize?: number;
  isOpen?: boolean;
}

const DropDownMenu = ({
  title,
  onPress,
  image,
  fontSize = 16,
  color = Colors.GrayPallete.lightgrayThree,
  isOpen,
}: IDropDownFilter) => {
  return (
    <TouchableOpacity
      onPress={() => {
        onPress();
      }}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        alignSelf: 'center',
        borderBottomWidth: 1,
        borderColor: Colors.lightGray,
        paddingRight: 20,
        height: 70,
      }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        {image}
        <Text
          style={{
            fontSize: fontSize,
            fontFamily: 'TCCC-UnityHeadline Regular',
            lineHeight: 18,
            marginLeft: 20,
            color: color,
          }}>
          {title}
        </Text>
      </View>
      {isOpen ? (
        <Entypo name="chevron-thin-up" size={16} color={'black'} />
      ) : (
        <Entypo name="chevron-thin-right" size={16} color={'black'} />
      )}
    </TouchableOpacity>
  );
};

export default DropDownMenu;
